app.component("preOpHistoryAmd", {
	templateUrl: "app/src/js/components/preOp/preOpHistory/preOpHistoryAmd/preOpHistoryAmd.html",
	controller: "preOpHistoryAmdController",
	bindings: {
		data: "=",
		eyeTitle: "@",
		eyeTitleLowercase: "@",
	},
});

app.controller("preOpHistoryAmdController", [
	"$scope",
	"PreOp",
	"$timeout",
	function ($scope, PreOp, $timeout) {
		this.$onInit = function () {
			this.PreOp = PreOp;
		};
		$scope.$watch("$ctrl.data.amd", function (newValue, oldValue) {
			if (newValue === 'NO') {
				$scope.$ctrl.data.prev_intravitreal_injections = null;
			}
		}, true);
	},
]);
